import {combineReducers} from "redux";
import ProductReducer from "../ProductReducer/ProductReducer"
const root =combineReducers({
    ProductReducer
})
export default root;